module.exports = __webpack_public_path__ + "img/new-food-pasta.5754365a.png";